import { useEffect } from 'react';
import { useIsEmbed } from './useIsEmbed';
import { LogError } from './loggingHelpers';

export const useIsEmbedSetup = () => {
  const { isEmbed } = useIsEmbed();
  useEffect(() => {
    try {
      if (isEmbed) {
        const sendHeight = () => {
          const params = new URLSearchParams(window.location.search);
          const origin = '*';
          const iframe = params.get('iframe');
          const defaultData = {
            name: 'documentHeightChange',
            documentHeight: 400,
            iframe,
          };
          const dataPayload = {
            ...defaultData,
            documentHeight: document.documentElement.getBoundingClientRect().height,
          };

          window.parent.postMessage(dataPayload, origin);
        };
        const sendHeightAfterTimeout = () => {
          // we need to wait for animation to finish before sending height as survey has popin animation
          setTimeout(sendHeight, 500);
        };
        const observer = new ResizeObserver(sendHeightAfterTimeout);
        observer.observe(document.documentElement);
        return () => {
          observer.disconnect();
        };
      }
    } catch (error) {
      // suppress/log error (this can happen if user is on legacy browser without ResizeObserver)
      LogError('Error in useIsEmbedSetup', error);
    }
    return () => {};
  }, [isEmbed]);
};
